import SweetAlert from 'react-bootstrap-sweetalert'

export const SweetAlertWithProp: any = SweetAlert
